import { z } from 'zod';
/**
 * Central de Ajuda (roadmap §2): FAQ e tutoriais da plataforma, gerenciados pelo super admin no Admin.
 * Cada item pode ser marcado com telas; o botão "?" da tela abre os itens dela.
 */
export const HELP_SCREENS = ['HOME', 'CALENDAR', 'CONVERSATIONS', 'CLIENTS', 'WAITLIST', 'SERVICES', 'TEAM', 'HOURS', 'AI_RULES', 'MESSAGES', 'WHATSAPP', 'PLAN', 'REPORTS', 'ONBOARDING', 'SETUP_WIZARD', 'HOME_SERVICE', 'RESOURCES', 'REACTIVATION', 'AUDIT', 'BUSINESS', 'TEST_MODE', 'PROFILE'];
export const HELP_STATUSES = ['DRAFT', 'PUBLISHED'];
/** Aceita o id (11 caracteres) ou qualquer URL do YouTube (watch, youtu.be, shorts, embed). */
export function youtubeId(input) {
    const v = input.trim();
    if (/^[\w-]{11}$/.test(v))
        return v;
    const m = v.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})/);
    return m ? m[1] : null;
}
export const slugSchema = z.string().trim().min(2).max(120).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, { message: 'INVALID_SLUG' });
const screens = z.array(z.enum(HELP_SCREENS)).max(HELP_SCREENS.length).default([]);
const locale = z.enum(['pt-BR', 'en-US']).default('pt-BR');
export const helpCategorySchema = z.object({
    name: z.string().trim().min(2).max(80),
    slug: slugSchema,
    icon: z.string().trim().max(40).nullable().optional(),
    sortOrder: z.number().int().min(0).max(10_000).default(0),
    locale,
});
export const helpVideoSchema = z.object({ youtubeId: z.string().trim().regex(/^[\w-]{11}$/, { message: 'INVALID_YOUTUBE_ID' }), title: z.string().trim().max(120).nullable().optional() });
export const helpTutorialSchema = z.object({
    categoryId: z.string().uuid().nullable().optional(),
    title: z.string().trim().min(3).max(160),
    slug: slugSchema,
    summary: z.string().trim().max(400).nullable().optional(),
    bodyMd: z.string().max(40_000).default(''),
    videos: z.array(helpVideoSchema).max(10).default([]),
    screens,
    status: z.enum(HELP_STATUSES).default('DRAFT'),
    locale,
    sortOrder: z.number().int().min(0).max(10_000).default(0),
});
export const helpFaqSchema = z.object({
    categoryId: z.string().uuid().nullable().optional(),
    question: z.string().trim().min(3).max(300),
    answerMd: z.string().trim().min(1).max(8_000),
    tutorialId: z.string().uuid().nullable().optional(),
    screens,
    status: z.enum(HELP_STATUSES).default('DRAFT'),
    locale,
    sortOrder: z.number().int().min(0).max(10_000).default(0),
});
//# sourceMappingURL=help.js.map